import { Component, ViewEncapsulation, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule, ValidatorFn, AbstractControl, ValidationErrors, FormArray } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { RickService } from '../service/rick.service';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-pieces-used',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule, MatExpansionModule],
  templateUrl: './pieces-used.component.html',
  styleUrl: './pieces-used.component.scss',
  providers: [RickService]
})
export class PiecesUsedComponent {
  @ViewChild('errorMessageDiv') errorDiv!: ElementRef;
  @ViewChild('successMessageDiv') successDiv!: ElementRef;
  piecesUsedForm: FormGroup = new FormGroup({});
  piecesUsedLotListForm: FormGroup = new FormGroup({});
  submitted: boolean = false;
  isSaved: boolean = false;
  lotList: any[] = [];
  customer: any = '';
  state: any = '';
  store: any = '';
  purchaseOrder: any = '';
  isPiecesUsedSubmitted: boolean = false;
  isLotDataReady: boolean = false;

  constructor(private fb: FormBuilder, private router: Router, private rickService: RickService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.piecesUsedForm = this.fb.group({
      customer: ['', Validators.required],
      state: ['', Validators.required],
      store: ['', Validators.required],
      purchaseOrder: ['', Validators.required]
    });

    this.piecesUsedLotListForm = this.fb.group({
      lotNumberPiecesUsedQtyListDtosList: this.fb.array([this.lotGroupDetails()])
    });
  }

  lotGroupDetails() {
    return this.fb.group({
      lotNumber: [''],
      piecesUsedQtyDtoList: this.fb.array([this.sizeDetailsGroup()])
    });
  }

  checkSizeDetailsErrors(field: string, errorType: string, lotIndex: number, dimensionIndex: number) {
    return (this.submitted &&
      ((((this.piecesUsedLotListForm.controls["lotNumberPiecesUsedQtyListDtosList"] as FormArray).controls[lotIndex] as FormGroup)
        .controls['piecesUsedQtyDtoList'] as FormArray).controls[dimensionIndex] as FormGroup).controls[field].errors?.[errorType]) ? true : false;
  }

  sizeDetailsGroup() {
    return this.fb.group({
      dim1: [''],
      dim2: [''],
      usedQty: ['', [
        Validators.pattern("^[0-9]*$")
      ]]
    });
  }

  getGroup(index: number) {
    return (this.piecesUsedLotListForm.controls["lotNumberPiecesUsedQtyListDtosList"] as FormArray).at(index) as FormGroup;
  }

  setupSizeDetailsData(data: any, indx: any) {
    let sizeDetailsArray: any = [];
    data.forEach((element: any, index: number) => {
      sizeDetailsArray.push({
        "dim1": element.dim1,
        "dim2": element.dim2
      });
      if (index != 0) {
        this.addSizeDetails(indx);
      }
    });
    (((this.piecesUsedLotListForm.controls["lotNumberPiecesUsedQtyListDtosList"] as FormArray).controls[indx] as FormGroup)
      .controls['piecesUsedQtyDtoList'] as FormArray).patchValue(sizeDetailsArray);
  }

  setupLotGroupList() {
    let lotGroupArray: any = [];
    this.lotList.forEach((element: any, index: number) => {
      if (index != 0) {
        this.addLotGroupDetails();
      }
      lotGroupArray.push({
        "lotNumber": element.lotNumber,
        "piecesUsedQtyDtoList": this.setupSizeDetailsData(element.piecesUsedQtyDtoList, index)
      });
    });
    (this.piecesUsedLotListForm.controls["lotNumberPiecesUsedQtyListDtosList"] as FormArray).patchValue(lotGroupArray);
  }

  addSizeDetails(i: any) {
    const sizeDetailsForm: FormGroup = this.sizeDetailsGroup();
    (((this.piecesUsedLotListForm.controls["lotNumberPiecesUsedQtyListDtosList"] as FormArray).controls[i] as FormGroup)
      .controls['piecesUsedQtyDtoList'] as FormArray).push(sizeDetailsForm);
  }

  addLotGroupDetails() {
    const lotGroupDetailsForm: FormGroup = this.lotGroupDetails();
    (this.piecesUsedLotListForm.controls["lotNumberPiecesUsedQtyListDtosList"] as FormArray).push(lotGroupDetailsForm);
  }

  fetchLotIds() {
    this.submitted = true;
    if (this.piecesUsedForm.valid) {
      this.customer = this.piecesUsedForm.controls.customer.value;
      this.state = this.piecesUsedForm.controls.state.value;
      this.store = this.piecesUsedForm.controls.store.value;
      this.purchaseOrder = this.piecesUsedForm.controls.purchaseOrder.value;
      this.rickService.fetchLotsByEDP(this.customer, this.state, this.store).subscribe((res) => {
        this.setupPiecesUsed(res);
      }, (error) => {
        this.piecesUsedForm?.setErrors({ invalid: error?.error?.errorMessages[0] });
        this.changeDetectorRef.detectChanges();
        this.errorDiv.nativeElement.scrollIntoView();
      });
    }
  }

  setupPiecesUsed(data: any) {
    this.lotList = data;
    this.setupLotGroupList();
    this.isLotDataReady = true;
  }

  cancelPage() {
    this.router.navigate(['/home']);
  }

  updatePiecesUsed() {
    console.log('dta is', this.piecesUsedLotListForm.value);
    if (this.piecesUsedLotListForm.valid) {
      this.isPiecesUsedSubmitted = true;
      let postData = {
        "poNumber": this.purchaseOrder,
        "edpNumberDto": {
          "customer": this.customer,
          "state": this.state,
          "store": this.store
        },
        "lotNumberPiecesUsedQtyListDtosList": this.piecesUsedLotListForm.controls['lotNumberPiecesUsedQtyListDtosList'].value
      };
        this.rickService.updatePiecesUsed(postData).subscribe((res) => {
          this.isSaved = true;
          this.changeDetectorRef.detectChanges();
          this.errorDiv.nativeElement.scrollIntoView();
        }, (error) => {
          this.piecesUsedLotListForm?.setErrors({ invalid: error?.error?.errorMessages[0] });
          this.changeDetectorRef.detectChanges();
          this.errorDiv.nativeElement.scrollIntoView();
        });
    }
  }

}
